import type { SupportedLanguages } from '../../i18n/constants';
import type { BundleItem } from '../rewards/types';

export type StampStatus = 'LOCKED' | 'AVAILABLE' | 'COMPLETED';
export type StampCardProgressRuleType = 'SPECIFIC_PACKAGE' | 'PRICE_THRESHOLD';

export type StampRewardPackage = {
  packageId: number;
  scCoin?: number | string | null;
  gcCoin?: number | string | null;
  amount?: number | string | null;
  bundleItems?: BundleItem[] | null;
};

export type StampCardStamp = {
  stampIndex: number;
  status: StampStatus;
  locked: boolean;
  unlocksAt?: string | null;
  unlockAnimationShown: boolean;
  freeStampAnimationShown: boolean;
  completedAt?: string | null;
  completedByPackageId?: number | null;
  hasReward: boolean;
  rewardClaimed?: boolean;
  claimedAt?: string | null;
  isFree: boolean;
  rewardPackage?: StampRewardPackage | null;
};

export const isStampLockedByTime = (stamp: Pick<StampCardStamp, 'unlocksAt'>): boolean =>
  !!stamp.unlocksAt && new Date(stamp.unlocksAt).getTime() > Date.now();

export interface StampCardCampaignAssets {
  lobbyWidgetWideUrl?: string | null;
  lobbyWidgetNarrowUrl?: string | null;
  popupLayoutUrl?: string | null;
  lockedStampAssetUrl?: string | null;
  emptyStampAssetUrl?: string | null;
  filledStampAssetUrl?: string | null;
  freeStampAssetUrl?: string | null;
  logoAssetUrl?: string | null;
  storeBannerUrl?: string | null;
}

export interface PlayerStampCard {
  userStampCardId: string;
  campaignId: string;
  campaignName: string;
  stampCount: number;
  timerSeconds: number | null;
  expiresAt: string | null;
  storeVisible: boolean;
  assets: StampCardCampaignAssets;
  stamps: StampCardStamp[];
  completedAt: string | null;
  progressRuleType: StampCardProgressRuleType;
  priceThreshold: number | null;
  stampText: Partial<Record<SupportedLanguages, string>> | null;
}
